export const NOTIFICATION_UPDATE_USER_MODAL = 'NOTIFICATION_UPDATE_USER_MODAL';
export const NOTIFICATION_CREDIT_CARD_MODAL = 'NOTIFICATION_CREDIT_CARD_MODAL';
export const NOTIFICATION_CONTACT_MESSAGE_SENT = 'NOTIFICATION_CONTACT_MESSAGE_SENT';
export const NOTIFICATION_GET_MESSAGE_BY_ID = 'NOTIFICATION_GET_MESSAGE_BY_ID';
export const NOTIFICATION_GET_MESSAGES = 'NOTIFICATION_GET_MESSAGES';
export const NOTIFICATION_SEND_EMAIL_CONFIRMATION = 'NOTIFICATION_SEND_EMAIL_CONFIRMATION';
